module.exports = __webpack_public_path__ + "img/set.5ca10180.svg";